<!-- ------------------------Компонент маленького модального вікна ----------------------------------- -->
<template>
  <portal to="modal">
    <div class="modal-lair">
      <div class="modal-container">
        <slot></slot>
      </div>
    </div>
  </portal>
</template>

<script>
import { keyevent } from '@/main.js'; // Імпорт глобального об'єкта keyevent для обміну подіями між компонентами

export default {
  mounted() {
    // Припиняє слухати подію 'esc', потім підписується заново, щоб при натисканні 'esc' викликати подію 'escape'
    keyevent.$off('esc');
    keyevent.$on('esc', () =>
      this.$emit('escape')
    );
  },
  beforeDestroy() {
    // Припиняє слухати подію 'enter' перед знищенням компонента
    keyevent.$off('enter');
  },
}
</script>

<style>
.modal-lair {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-container {
  min-width: 300px;
  /* width: 50%; */
  background: #fff;
  padding: 15px;
  border-radius: 0.25rem;
}

@media screen and (max-width: 700px) {
  .modal-container {
    width: 90%;
  }
}

/* це потрібно для роботи стилів у checkPassword.vue, rePassword.vue та transferCompany.vue */
.passwordCheck,
.old-password,
.new-password,
.repeat-password,
.transfer-company-pass {
  position: relative;
}
</style>